import * as React from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  main?: string;
  highlight?: string;
  secondary?: string;
  tertiary?: string;
}

export function BookReading({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width={1022.84}
      height={813.16}
      viewBox="0 0 1022.84 813.16"
      aria-labelledby={titleId}
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__a"
          x1={635.22}
          y1={545.34}
          x2={635.22}
          y2={43.42}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
      </defs>
      {title === undefined ? (
        <title id={titleId}>{'book lover'}</title>
      ) : title ? (
        <title id={titleId}>{title}</title>
      ) : null}
      <path
        d="M599.86 137.42c-64.72-2.25-126.37-23.14-185.23-46S297.47 43.23 234.3 31.12c-40.63-7.79-87.1-8.89-119.83 12.89-31.51 21-41.69 57.15-47.16 90.73-4.12 25.26-6.54 51.84 4.75 75.49 7.83 16.42 21.74 30.22 31.35 46 33.47 54.72 9.82 122.2-26.45 175.63-17 25.07-36.75 49-49.87 75.66s-19.2 57.25-7.72 84.47c11.39 27 38.52 47.24 67.9 61.49 59.69 28.95 130 37.23 198.61 41.92 151.83 10.39 304.46 5.89 456.69 1.39 56.34-1.67 112.92-3.36 168.34-12.07 30.78-4.84 62.55-12.51 84.9-31.05 28.36-23.53 35.39-63.38 16.39-92.88-31.89-49.49-120-61.78-142.32-114.9-12.26-29.23.34-61.79 18.16-88.91 38.24-58.16 102.33-109.19 105.71-175.67 2.32-45.67-28.5-91.39-76.14-113-49.93-22.73-119.19-19.85-156.01 17.64-37.94 38.63-104.6 53.45-161.74 51.47z"
        fill={props?.tertiary || '#6c63ff'}
        opacity={0.1}
      />
      <path
        fill={props?.tertiary || '#6c63ff'}
        d="M435.45 690.5l-342.28-1.67-34.01-79.77 120.26-8.73-20.96-87.46 237.86-30.83-227.77-79.18 20.12-4.78 366.25 59.75-20.17 136.49-28.83 75.01-70.47 21.17z"
      />
      <path
        d="M98.42 655.42s21-3.36 33.6 11.48c0 0-9.24 7.28-29.12-2.8zM96.22 655.09s-13.4 16.49-6.8 34.85c0 0 10.92-4.37 12.11-26.63zM84.18 627.98s8.4-15.41 42 6.16c0 0-4.48 10.36-19.32 9.52s-18.76-7.56-22.68-15.68zM82.01 626.87s-17.43-2-19.12 37.9c0 0 11.05 2.29 18.9-10.33s4.63-19.7.22-27.57zM71.86 595.04s9.8-27.16 45.36-7.84c0 0-8.12 24.92-41.72 17.08zM60.94 554.44s18.48-27.44 51.24-2c0 0-11.48 25.76-48.44 11.76zM57.02 515.8s21.56-25.21 54 0c0 0-20.44 22.12-54 6.44zM53.66 478.27s21.84-26.32 52.92-1.4c0 0-24.64 23.24-52.92 7.56zM55.62 444.95s23-33.88 52.08-10.92c0 0-24.64 29.12-52.08 17.36zM60.94 406.03s24.36-33.6 52.64-7.84c0 0-28.84 29.12-52.64 14zM69.06 371.24s28.84-31.58 54-19c0 0-30.05 33.54-55.26 27.38zM79.14 338.26s33.28-38.68 52.64-25.76c0 0-24.52 30-55 33zM93.69 300.01s29.13-31.58 50.41-23.74c0 0-24.92 32.76-54.32 33.6zM106.86 264.23s32.2-30.24 46.2-24.92c0 0-23.24 33.6-47.6 31.64zM119.74 231.19s27.72-36.13 42.85-33.33c0 0-16.81 32.21-42.85 37zM133.72 186.64s24.5-27.69 37.74-27.63c0 0-19.34 37-38.75 36.66zM142 156.98l23.67-57.68s1.18 52.14-26.68 68.38zM151.61 93.37s3.92-48.17 1.4-52.09c0 0 16.92 40.05-1.56 73.37zM70.94 594.4s-24.54-15.21-40.43 22c0 0 21.84 14.5 43.32-12.51zM60.15 552.89s-30.1-13.73-44.7 25.12c0 0 23.25 16 47.44-15.3zM55.62 518.11s-21.56-25.21-54 0c0 0 20.44 22.12 54 6.44zM52.92 478.27S31.08 451.95 0 476.87c0 0 24.64 23.24 52.92 7.56z"
        fill={props?.tertiary || '#6c63ff'}
      />
      <path
        d="M55.62 445.91S40.3 407.96 7 424.28c0 0 18 33.65 47.26 27.93zM62.87 405.84s-15.23-38.61-49-20.71c0 0 20.68 35.39 47.5 26.67zM72.31 371.43s-6-42.33-34-46.12c0 0 5.94 44.64 30.23 53.75zM79.85 338.34s-2.34-51-25.49-52.78c0 0 .78 38.71 22.88 60zM96.09 298.58s-6.9-42.41-29-47.59c0 0 2.74 41.07 26.81 58zM109.48 264.58s-.23-44.18-13.73-50.67c0 0-8.37 40 9.82 56.31zM120.77 230.69s-1.89-45.49-15.87-51.9c0 0-4.78 36 13.78 54.88zM135.67 190.27s-.08-37-10.06-45.68c0 0-9.92 40.53 4.85 53.12z"
        fill={props?.tertiary || '#6c63ff'}
      />
      <path
        d="M140.83 155.16l-9.71-61.58s-13.19 50.46 10.17 72.7zM142.72 93.95s-24.92-41.4-24.41-46c0 0 2.65 43.39 34 65zM145.64 81.72s-23.52-58.8-34.16-63.56c0 0 33.6 17.08 36.12 61.88z"
        fill={props?.tertiary || '#6c63ff'}
      />
      <path
        d="M132.59 196.02l-1.61-.49c19.85-64.73 24.8-106 13.95-116.35l1.15-1.22c11.51 10.92 6.84 51.74-13.49 118.06z"
        fill="#444053"
      />
      <path
        d="M77.93 347.58l-2.38-.85c2.11-5.93 4.38-11.95 6.76-17.88 20.72-51.64 38.36-99.68 49.67-136.56l2.07-1c-11.33 36.95-28.66 86.83-49.4 138.54-2.37 5.82-4.63 11.81-6.72 17.75z"
        fill="#444053"
      />
      <path
        d="M128.01 703.86c-.32-.35-32.49-36.58-54.92-98.43a364.18 364.18 0 01-21.67-112.78c-1.54-48.13 8.56-101.87 25.86-150.69l1.88 2.2c-38.84 109.57-23.41 203.46-2.94 260 22.19 61.29 54 97.12 54.31 97.48z"
        fill="#444053"
      />
      <path
        d="M630.73 626.94s-22.67 27.67-4.67 69.5l-181 78.5-17.37 3.64-8-35 5.35-44.17v-24.14z"
        fill="#d5d6db"
      />
      <path
        fill={props?.tertiary || '#6c63ff'}
        d="M59.16 609.06l250.52-45.67 331.95 52.88-206.18 74.23-376.29-81.44z"
      />
      <path
        fill={props?.tertiary || '#6c63ff'}
        d="M59.16 609.06l250.52-45.67 331.95 52.88-206.18 74.23-376.29-81.44z"
      />
      <path
        d="M59.16 609.05s-23.43 44.39 3.57 85.39l371.5 80.5s-23.06-35.36 1.19-84.44z"
        fill={props?.tertiary || '#6c63ff'}
      />
      <path
        d="M59.16 609.05s-23.43 44.39 3.57 85.39l371.5 80.5s-23.06-35.36 1.19-84.44zM70.23 624.44s-13.39 32.48 0 53.5"
        opacity={0.1}
      />
      <path
        d="M434.23 774.94l207.4-88.5s11.6 2.5 4.1 11-207.5 86-207.5 86l-375.5-89z"
        fill={props?.tertiary || '#6c63ff'}
      />
      <path
        d="M434.23 774.94l207.4-88.5s11.6 2.5 4.1 11-207.5 86-207.5 86l-375.5-89zM417.23 699.44s-20 24 0 60"
        opacity={0.1}
      />
      <path
        opacity={0.1}
        d="M424.348 728.963l89.71-29.929.316.949-89.71 29.929zM424.32 737.012l107.705-40.956.356.935-107.706 40.956zM424.92 746.506l123.607-50.594.379.926L425.3 747.432zM426.364 754.87l140.108-63.29.411.911-140.108 63.29zM427.473 758.946l154.074-67.345.4.916-154.074 67.345zM429.796 765.786L614.522 686l.397.918-184.726 79.786z"
      />
      <path
        fill="#fff"
        opacity={0.3}
        d="M152.23 613.94l176-37 107.22 20.5-144.22 46.5-139-30z"
      />
      <path
        d="M641.63 616.27s9.1 3.67 3.76 9.34-209.97 64.89-209.97 64.89z"
        fill={props?.tertiary || '#6c63ff'}
      />
      <path
        d="M730.02 530.76s-22.66 27.66-4.66 69.5l-181 78.5-17.37 3.66-8-35 5.43-44.16v-24.17z"
        fill="#d5d6db"
      />
      <path
        fill="#3a3768"
        d="M158.46 512.87l250.51-45.66 331.96 52.88-206.18 74.23-376.29-81.45z"
      />
      <path
        d="M158.42 512.87s-23.44 44.39 3.56 85.39l371.5 80.5s-23.05-35.39 1.23-84.45z"
        fill="#3a3768"
      />
      <path
        d="M158.42 512.87s-23.44 44.39 3.56 85.39l371.5 80.5s-23.05-35.39 1.23-84.45l-117.48-25.43zM169.52 528.26s-13.38 32.47 0 53.5"
        opacity={0.1}
      />
      <path
        d="M533.52 678.76l207.41-88.5s11.59 2.5 4.09 11-207.5 86-207.5 86l-375.5-89z"
        fill="#3a3768"
      />
      <path
        d="M533.52 678.76l207.41-88.5s11.59 2.5 4.09 11-207.5 86-207.5 86l-375.5-89zM516.52 603.26s-20 24 0 60"
        opacity={0.1}
      />
      <path
        opacity={0.1}
        d="M523.646 632.794l89.709-29.93.316.95-89.709 29.929zM523.63 640.838l107.706-40.956.355.934-107.705 40.957zM524.217 650.318l123.606-50.594.379.926-123.607 50.594zM525.67 658.684l140.109-63.29.412.911-140.109 63.29zM526.766 662.747l154.074-67.345.4.916-154.074 67.346zM529.097 669.587l184.726-79.785.397.918-184.727 79.785z"
      />
      <path
        fill="#fff"
        opacity={0.45}
        d="M251.53 517.76l176-37 107.22 20.5-144.22 46.5-139-30z"
      />
      <path
        d="M740.93 520.09s9.09 3.67 3.76 9.33-209.94 64.89-209.94 64.89z"
        fill="#3a3768"
      />
      <path
        d="M739.42 420.73s-22.67 49.67-4.67 91.5l-181 56.5-17.33 3.67-8-35 5.35-44.17v-24.17z"
        fill="#d5d6db"
      />
      <path
        fill={props?.tertiary || '#6c63ff'}
        d="M167.89 402.85l250.52-45.67 331.96 52.88-206.19 74.23-376.29-81.44z"
      />
      <path
        d="M167.89 402.84s-23.47 44.39 3.53 85.39l371.5 80.5s-23.06-35.39 1.22-84.44z"
        fill={props?.tertiary || '#6c63ff'}
      />
      <path
        d="M167.89 402.84s-23.47 44.39 3.53 85.39l371.5 80.5s-23.06-35.39 1.22-84.44zM178.96 418.23s-13.39 32.48 0 53.5"
        opacity={0.1}
      />
      <path
        d="M542.96 568.73l207.4-66.5s11.6 2.5 4.1 11-207.5 64-207.5 64l-375.5-89z"
        fill={props?.tertiary || '#6c63ff'}
      />
      <path
        d="M542.96 568.73l207.4-66.5s11.6 2.5 4.1 11-207.5 64-207.5 64l-375.5-89zM525.96 493.23s-20 24 0 60"
        opacity={0.1}
      />
      <path
        opacity={0.1}
        d="M533.089 522.762l89.709-29.93.316.95-89.709 29.929zM533.066 530.811l107.706-40.956.355.935-107.706 40.956zM533.643 540.296l123.607-50.594.378.926-123.606 50.594zM535.111 548.654l140.109-63.291.411.911-140.108 63.29zM536.211 552.726l154.075-67.346.4.917-154.074 67.345zM538.54 559.572l184.726-79.785.396.918-184.726 79.785z"
      />
      <path
        fill="#fff"
        opacity={0.3}
        d="M260.96 407.73l176-37 107.22 20.5-144.22 46.5-139-30z"
      />
      <path
        d="M750.36 410.06s9.1 3.67 3.76 9.34-209.94 64.89-209.94 64.89zM310.42 106.5s-38-2.29-33.56 24.37c0 0-.89 4.71 3.38 6.85 0 0 .07-2 3.9-1.31a17.05 17.05 0 004.14.2 8.62 8.62 0 005.05-2.08s10.69-4.42 14.85-21.9c0 0 3.08-3.81 3-4.79l-6.44 2.74s2.19 4.63.47 8.48c0 0-.21-8.31-1.45-8.12-.25 0-3.33 1.61-3.33 1.61s3.77 8.07.92 13.93c0 0 1.08-9.94-2.1-13.35l-4.52 2.64s4.41 8.33 1.42 15.13c0 0 .77-10.43-2.37-14.49l-4.1 3.2s4.15 8.21 1.62 13.85c0 0-.33-12.14-2.5-13.06 0 0-3.59 3.16-4.13 4.46 0 0 2.84 6 1.07 9.11 0 0-1.07-8.09-2-8.13 0 0-3.57 5.36-3.94 9a19.46 19.46 0 013.07-9.54 10.71 10.71 0 00-5.46 2.83s.55-3.79 6.35-4.12c0 0 2.95-4.07 3.74-4.31 0 0-5.77-.49-9.26 1.06 0 0 3.08-3.57 10.31-2l4-3.3s-7.58-1-10.8.11c0 0 3.71-3.16 11.89-.86l4.41-2.63s-6.47-1.39-10.32-.89c0 0 4.06-2.19 11.61.18l3.14-1.41s-4.73-.93-6.12-1.08-1.46-.53-1.46-.53a16.51 16.51 0 018.9 1s6.75-2.43 6.62-2.85z"
        fill={props?.tertiary || '#6c63ff'}
      />
      <path
        d="M845.02 216.08s-38-2.29-33.56 24.37c0 0-.89 4.71 3.38 6.85 0 0 .07-2 3.9-1.31a17.62 17.62 0 004.14.2 8.59 8.59 0 005-2.08s10.7-4.42 14.85-21.9c0 0 3.08-3.81 3-4.79l-6.42 2.74s2.19 4.63.47 8.48c0 0-.21-8.31-1.44-8.12-.25 0-3.34 1.61-3.34 1.61s3.77 8.07.93 13.93c0 0 1.08-9.94-2.11-13.35l-4.52 2.64s4.41 8.33 1.42 15.13c0 0 .77-10.43-2.37-14.49l-4.09 3.2s4.14 8.21 1.61 13.85c0 0-.33-12.14-2.5-13.06 0 0-3.58 3.16-4.13 4.46 0 0 2.84 6 1.08 9.11 0 0-1.08-8.09-2-8.13 0 0-3.57 5.36-3.94 9a19.4 19.4 0 013.08-9.54 10.76 10.76 0 00-5.47 2.83s.56-3.79 6.35-4.12c0 0 2.95-4.07 3.74-4.32 0 0-5.76-.48-9.26 1.07 0 0 3.08-3.57 10.31-2l4-3.3s-7.59-1-10.8.11c0 0 3.7-3.16 11.89-.86l4.4-2.63s-6.47-1.39-10.32-.89c0 0 4.06-2.19 11.61.18l3.15-1.41s-4.74-.93-6.13-1.08-1.46-.53-1.46-.53a16.39 16.39 0 018.9 1s6.77-2.43 6.65-2.85zM374.42 271.2s-16.56-34.33-37.64-17.41c0 0-4.55 1.52-4.33 6.29 0 0 1.75-.91 3 2.77a17.72 17.72 0 001.84 3.7 8.63 8.63 0 004.29 3.4s9.07 7.18 26.36 2.28c0 0 4.83.83 5.62.25l-5.52-4.27s-3 4.17-7.18 4.54c0 0 7.16-4.23 6.39-5.21-.16-.2-3-2.13-3-2.13s-5.21 7.23-11.71 7.6c0 0 9.2-3.9 10.62-8.35l-4.5-2.66s-5.13 7.92-12.52 8.62c0 0 9.48-4.41 11.49-9.13l-4.78-2s-5.15 7.62-11.31 8.17c0 0 10.44-6.21 10.18-8.56 0 0-4.51-1.58-5.91-1.43 0 0-3.82 5.39-7.42 5.39 0 0 6.53-4.89 6.13-5.68 0 0-6.42-.5-9.8 1a19.47 19.47 0 019.83-2 10.77 10.77 0 00-5.14-3.39s3.58-1.36 6.69 3.53c0 0 5 .59 5.59 1.16 0 0-2.39-5.26-5.44-7.55 0 0 4.62.93 6.73 8l4.85 1.92s-2.79-7.12-5.36-9.37c0 0 4.56 1.69 6.55 10l4.44 2.56s-1.93-6.33-4.25-9.44c0 0 3.89 2.48 5.5 10.22l2.77 2.06s-1.5-4.59-2-5.87-.25-1.54-.25-1.54a16.41 16.41 0 013.48 8.25s5.35 4.58 5.71 4.28zM758.2 167.58s-16.55-34.33-37.64-17.41c0 0-4.54 1.52-4.33 6.29 0 0 1.76-.9 3 2.77a17.34 17.34 0 001.85 3.71 8.58 8.58 0 004.28 3.39s9.08 7.18 26.36 2.29c0 0 4.83.82 5.63.24l-5.49-4.28s-3 4.18-7.17 4.55c0 0 7.15-4.24 6.38-5.22-.16-.2-3-2.13-3-2.13s-5.2 7.23-11.71 7.6c0 0 9.21-3.9 10.63-8.34l-4.57-2.64s-5.12 7.91-12.52 8.62c0 0 9.48-4.42 11.5-9.14l-4.79-2s-5.15 7.63-11.3 8.17c0 0 10.43-6.21 10.17-8.55 0 0-4.5-1.59-5.9-1.43 0 0-3.82 5.38-7.43 5.38 0 0 6.54-4.89 6.14-5.68 0 0-6.42-.5-9.81 1a19.46 19.46 0 019.83-2 10.71 10.71 0 00-5.13-3.39s3.58-1.36 6.69 3.53c0 0 5 .6 5.59 1.17 0 0-2.39-5.27-5.45-7.56 0 0 4.62.94 6.73 8.05l4.86 1.92s-2.79-7.13-5.36-9.38c0 0 4.56 1.69 6.54 10l4.45 2.56s-1.94-6.32-4.26-9.44c0 0 3.9 2.48 5.5 10.22l2.77 2.06s-1.49-4.59-2-5.87-.25-1.53-.25-1.53a16.45 16.45 0 013.47 8.25s5.43 4.54 5.74 4.22zM811.09 337.39s-16.55-34.34-37.67-17.42c0 0-4.54 1.52-4.33 6.29 0 0 1.76-.9 3 2.77a17.33 17.33 0 001.84 3.71 8.58 8.58 0 004.28 3.39s9.08 7.19 26.37 2.29c0 0 4.82.83 5.62.24l-5.52-4.27s-3 4.18-7.18 4.55c0 0 7.15-4.24 6.38-5.22-.16-.2-3-2.13-3-2.13s-5.2 7.23-11.71 7.61c0 0 9.21-3.91 10.63-8.35l-4.51-2.66s-5.12 7.92-12.52 8.62c0 0 9.48-4.42 11.5-9.14l-4.79-2s-5.15 7.62-11.3 8.17c0 0 10.44-6.21 10.18-8.56 0 0-4.51-1.59-5.91-1.43 0 0-3.82 5.38-7.43 5.38 0 0 6.54-4.89 6.14-5.68 0 0-6.42-.5-9.81 1a19.52 19.52 0 019.84-2 10.69 10.69 0 00-5.14-3.39s3.58-1.37 6.69 3.53c0 0 5 .59 5.59 1.16 0 0-2.39-5.26-5.44-7.56 0 0 4.62.94 6.73 8.05l4.85 1.92s-2.79-7.13-5.36-9.37c0 0 4.56 1.68 6.54 10l4.45 2.55s-1.94-6.32-4.26-9.44c0 0 3.9 2.48 5.51 10.23l2.77 2s-1.5-4.59-2-5.87-.25-1.53-.25-1.53a16.35 16.35 0 013.47 8.25s5.44 4.61 5.75 4.31z"
        fill={props?.tertiary || '#6c63ff'}
        opacity={0.1}
      />
      <ellipse
        cx={201.95}
        cy={781.59}
        rx={22.99}
        ry={2.57}
        fill={props?.tertiary || '#6c63ff'}
        opacity={0.1}
      />
      <ellipse
        cx={51.24}
        cy={737.91}
        rx={22.99}
        ry={2.57}
        fill={props?.tertiary || '#6c63ff'}
        opacity={0.1}
      />
      <ellipse
        cx={316.83}
        cy={810.6}
        rx={22.99}
        ry={2.57}
        fill={props?.tertiary || '#6c63ff'}
        opacity={0.1}
      />
      <ellipse
        cx={905.53}
        cy={747.41}
        rx={22.99}
        ry={2.57}
        fill={props?.tertiary || '#6c63ff'}
        opacity={0.1}
      />
      <ellipse
        cx={714.22}
        cy={734.94}
        rx={22.99}
        ry={2.57}
        fill={props?.tertiary || '#6c63ff'}
        opacity={0.1}
      />
      <ellipse
        cx={590.46}
        cy={793.66}
        rx={27.19}
        ry={4.67}
        fill={props?.tertiary || '#6c63ff'}
        opacity={0.1}
      />
      <path
        d="M602.59 746.72s-37.86 19.56-18.3 42.6c0 0 1.84 5 7.16 4.65 0 0-1.06-1.94 3-3.49a19.51 19.51 0 004.09-2.17 9.61 9.61 0 003.66-4.89s7.74-10.36 1.74-29.53c0 0 .78-5.42.1-6.3l-4.6 6.31s4.75 3.19 5.3 7.88c0 0-5-7.87-6-7-.22.18-2.28 3.45-2.28 3.45s8.24 5.59 8.85 12.85c0 0-4.64-10.17-9.65-11.62l-2.87 5.12s9 5.48 10 13.72c0 0-5.23-10.45-10.57-12.56l-2.11 5.41s8.68 5.52 9.48 12.38c0 0-7.26-11.47-9.87-11.11 0 0-1.64 5.08-1.42 6.65 0 0 6.13 4.1 6.24 8.13 0 0-5.66-7.15-6.53-6.68 0 0-.36 7.19 1.38 10.93 0 0-3-5.34-2.51-10.93a12 12 0 00-3.63 5.84s-1.63-3.95 3.74-7.59c0 0 .51-5.59 1.13-6.28 0 0-5.81 2.84-8.28 6.32 0 0 .91-5.19 8.79-7.77l2-5.48s-7.88 3.34-10.31 6.28c0 0 1.75-5.15 10.93-7.62l2.72-5s-7 2.36-10.42 5c0 0 2.65-4.43 11.26-6.47l2.21-3.15s-5.08 1.81-6.5 2.46-1.7.33-1.7.33a18.39 18.39 0 019.11-4.14s5.01-6.19 4.66-6.53z"
        fill={props?.tertiary || '#6c63ff'}
      />
      <path
        d="M803.54 420.71C797 402.94 761 401.27 745.38 405.8c-11.1 3.23-34.5 6.87-47 8.7l-.81-.77c1.62-.48 1.66-1.66 1.46-3.41a53.37 53.37 0 01.1-6.92c7.66 2.38 14.48-3.25 14.48-3.25 9-4 6.58-21.12 8.3-25.8 1.29-3.5 2.68-24.12 3.3-34.4h.13l.07-3.45c.09-1.49.13-2.36.13-2.36s.88-25.14 2.6-30.23c1.6-4.68 2.9-28.26 3.1-32v-.49l-.13-2.18c.09-1.59.13-3.36.12-5.22 0-8.55-.89-19.32-1-21.06v-.91c.07-3.65-.39-21.93-15.94-28.84-5.73-2.56-12.62-5.61-19.29-8.58-1.72-14.85-5.65-29.62-5.31-44.58 0-2.25.2-4.5.42-6.74 0 .65-.07 1.31-.08 2v4.36c.59-18.71 7.66-37.52 7-55.83-.06 1.79-.19 3.59-.36 5.39a58.13 58.13 0 00-1.92-18.39c-.6-2.11-1.41-4.29-3.14-5.7a12.93 12.93 0 00-5.48-2.17 110.21 110.21 0 00-14.39-2.68A22.22 22.22 0 00668.5 74c-10.14-13.92-25.16-27-42.92-30-8.91-1.5-19.16-.25-25.22 6.12a18.92 18.92 0 00-1.78 1.8c-3.26 3.89-4.66 9-8 12.88-.22.26-.47.5-.71.75-6.54 5.85-16.73 7.07-24 12.32a28.81 28.81 0 00-3.59 3.13 60.88 60.88 0 00-7.84 9.53c-3.27 4.6-6.63 9.39-7.67 14.88-2.09 11 5.4 21.43 6.79 32.5 3.1 24.77-24.31 46.75-19.12 71.19a32.6 32.6 0 008.82 15.83c-10.69 9.68-19.79 19.07-19.79 19.07v.56h-1.69l.17 2h-.17l.93 10.85-.93 15.8v1.49h.06c.31 5.79 1.54 26.61 3 31 1.72 5.09 2.59 30.23 2.59 30.23s1.9 35.53 3.64 40.23-.73 21.77 8.3 25.8a19 19 0 009.07 3.76c-.46 3.74-.17 6.45 1.32 7.3a4.36 4.36 0 002.1.6 22.29 22.29 0 00-1.63 2.85 42.36 42.36 0 01-10.48-2.47c-9.7-4-41.89-13-51.24-6.67s-31.85 12.07-21.46 37.55S482.28 471 482.28 471a37 37 0 018.31 8.35c3.12 4.69 32.19 15.42 39.46 15.42a71.19 71.19 0 019.25.46s-7.89 6.92-6.84 10.94-2.4 36.2-2.4 36.2 8 8.06 11.42-2.51l.12.16c.64.87 4.1 4.8 10.61-.16a59.48 59.48 0 018.46-5.36l31.52-4.46a89.24 89.24 0 019.87-.07c5 .41 9.91-2.55 13-4.84 6.53 2.48 13.87 5.19 17.36 6.18 7.08 2 39.62 10.73 47.23 8a10.57 10.57 0 004.1-2.92l7.26.23-3.4.68s6.62.11 15.62.23l-.38.22 11.29-.1c16.52.15 35.08.2 37.52-.35 3.82-.85 23.67-.25 29.52 0h1.63s21.81-4.35 12.81-26.48c-6.92-17-28.19-21.94-37.63-23.3 2.66-.53 4.95-.94 6.47-1.18 6.59-1 19.39-7 20.43-9.05s11.77-8 14.54-11.39 10.68-27.42 4.11-45.19zm-180.65 49.73l-1.07.35-.72.24-1.38 1.36c-1.1-.74-2.28-1.52-3.51-2.32 2.17.13 4.4.26 6.68.37zm95.31 28.18z"
        transform="translate(-88.58 -43.42)"
        fill="url(#prefix__a)"
      />
      <path
        d="M598.07 321.58s15.3 40 24 36 6.34-21 8-25.66 3.5-40 3.5-40 .84-25 2.5-30.06c1.54-4.65 2.79-28.1 3-31.79v-.49l-1.65-29-9.34-2.33-21.66 8-3 17.13-1.17 6.69-.5 2.85z"
        fill="#be6f72"
      />
      <path
        d="M603.11 314.88s14.6 11.95 19 13 7.1 10.37 7.1 10.37"
        opacity={0.1}
      />
      <path
        d="M478.42 323.33s-15.3 40-24 36-6.34-21-8-25.66-3.5-40-3.5-40-.84-25-2.5-30.06c-1.54-4.65-2.79-28.1-3-31.79v-.49l1.66-29 9.34-2.33 21.66 8 3 17.13 1.17 6.69.5 2.85z"
        fill="#be6f72"
      />
      <path fill="#3e373a" d="M543.9 109.27h34.15v53.23H543.9z" />
      <path opacity={0.1} d="M543.9 109.27h34.15v53.23H543.9z" />
      <path
        d="M472.42 363.17s-11.67 12.83-7.34 15.16 32.34 46 32.34 46 92 11.33 109.35-5.67 17-47.37 17-47.37-13.94 3-15.46 1.37-9.87-9.49-9.87-9.49-118.02-7.16-126.02 0z"
        fill="#4b4b5b"
      />
      <path
        d="M472.42 363.17s-11.67 12.83-7.34 15.16 32.34 46 32.34 46 92 11.33 109.35-5.67 17-47.37 17-47.37-13.94 3-15.46 1.37-9.87-9.49-9.87-9.49-118.02-7.16-126.02 0z"
        opacity={0.02}
      />
      <path
        d="M638.04 201l-30 24-9.07.66-3.33.24-55.93 4.1-58-4.24-8.63-.63-11-.8-23-22s16.28-17.44 30.54-29.21c5.62-4.65 10.93-8.41 14.8-9.89l.66-.23a16.46 16.46 0 006.34-4.42c11.26-11.61 21.67-40.26 21.67-40.26s49.67-25.66 43.67 8 22.33 25.34 22.33 25.34l9.34 4.26 3.69 1.69 9.41 4.31 21.23 9.74c16.66 7.67 15.28 29.34 15.28 29.34z"
        fill="#be6f72"
      />
      <circle cx={537.38} cy={101.06} r={44.67} opacity={0.1} />
      <path
        d="M638.11 232.82H437.42v-.49l1.66-29s16.28-17.44 30.54-29.21l126-5 5.86-6.18 21.23 9.74c16.67 7.66 15.33 29.33 15.33 29.33s2.28 25.11.07 30.81z"
        opacity={0.1}
      />
      <path
        d="M638.11 231.82H437.42v-.49l1.66-29s16.28-17.44 30.54-29.21l126-5 5.86-6.18 21.23 9.74c16.67 7.66 15.33 29.33 15.33 29.33s2.28 25.11.07 30.81z"
        fill="#e7c7ca"
      />
      <path
        d="M505.21 150.5s31.66 40.34 73.83-.83 4.67 91.83 4.67 91.83l-91 10.8z"
        opacity={0.1}
      />
      <path
        d="M505.21 152.5s31.66 40.34 73.83-.83 4.67 91.83 4.67 91.83l-91 10.8z"
        fill="#e7c7ca"
      />
      <path
        d="M592.07 159.58l3.35 51.09 3.59 17 2.74 13s7 100 5 105 1 9 1.42 11.66-.42 9.34-.09 12.34 0 4.33-7.66 3.26-18.34-2.93-18.34-2.93-27 2-36.33-1.33-27-3.34-27-3.34-26.67.67-35.33-.33-13.34 10.67-19 7.33 6.66-35.66 10.66-45-5.33-33-5.33-33l12-66.57 2.67-15.09v-47.44l.66-.23a16.46 16.46 0 006.34-4.42l3 47.74 94 3.34v-53.73"
        opacity={0.1}
      />
      <path
        d="M592.07 157.58l3.35 51.09 3.59 17 2.74 13s7 100 5 105 1 9 1.42 11.66-.42 9.34-.09 12.34 0 4.33-7.66 3.26-18.34-2.93-18.34-2.93-27 2-36.33-1.33-27-3.34-27-3.34-26.67.67-35.33-.33-13.34 10.67-19 7.33 6.66-35.66 10.66-45-5.33-33-5.33-33l12-66.57 2.67-15.09v-47.44l.66-.23a16.46 16.46 0 006.34-4.42l3 47.74 94 3.34v-53.73"
        fill="#e7c7ca"
      />
      <path
        d="M602.88 50.96c-.57-2.09-1.36-4.26-3-5.66a12.28 12.28 0 00-5.28-2.16 104.32 104.32 0 00-13.88-2.66 22.22 22.22 0 00-3-6.23c-9.8-13.84-24.3-26.89-41.36-29.84-8.93-1.55-19.28-.16-25 6.88-3.14 3.87-4.49 9-7.66 12.8-6.11 7.38-17.14 8.29-24.84 14-4.11 3-7.09 7.35-10 11.57-3.15 4.57-6.39 9.33-7.39 14.79-2 10.91 5.21 21.31 6.54 32.32 3 24.63-23.4 46.48-18.41 70.78 2.91 14.17 16 24.15 29.54 29.21 4.77 1.79 10.22 3.57 12.45 8.15 1 2 1.17 4.31 2.11 6.33 3.16 6.74 13.55 7 19.13 2.09s7.34-12.85 8-20.26c2.68-32.36-10.28-64.33-8.77-96.77.45-9.81 3.21-20.94 12-25.38 11.83-6 26.06 4 39.08 2.09a77.53 77.53 0 013.74 47.31c-2.07 8.63-5.65 17-5.91 25.9-.39 13.55 6.92 25.93 13.24 37.91a20.17 20.17 0 012.67 7.31 17.62 17.62 0 01-1.43 7.65c-3.57 9.61-9.73 18.53-10.43 28.76a4.65 4.65 0 00.75 3.42 4.3 4.3 0 002.58 1.16c10.8 1.85 20.14-7.72 25.41-17.33a81.24 81.24 0 0010.02-34.52c1.09-20.36-6.21-40.39-5.76-60.77.52-23.17 10.99-46.5 4.86-68.85z"
        opacity={0.1}
      />
      <path
        d="M603.88 49.96c-.57-2.09-1.36-4.26-3-5.66a12.28 12.28 0 00-5.28-2.16 104.32 104.32 0 00-13.88-2.66 22.22 22.22 0 00-3-6.23c-9.8-13.84-24.3-26.89-41.36-29.84-8.93-1.55-19.28-.16-25 6.88-3.14 3.87-4.49 9-7.66 12.8-6.11 7.38-17.14 8.29-24.84 14-4.11 3-7.09 7.35-10 11.57-3.15 4.57-6.39 9.33-7.39 14.79-2 10.91 5.21 21.31 6.54 32.32 3 24.63-23.4 46.48-18.41 70.78 2.91 14.17 16 24.15 29.54 29.21 4.77 1.79 10.22 3.57 12.45 8.15 1 2 1.17 4.31 2.11 6.33 3.16 6.74 13.55 7 19.13 2.09s7.34-12.85 8-20.26c2.68-32.36-10.28-64.33-8.77-96.77.45-9.81 3.21-20.94 12-25.38 11.83-6 26.06 4 39.08 2.09a77.53 77.53 0 013.74 47.31c-2.07 8.63-5.65 17-5.91 25.9-.39 13.55 6.92 25.93 13.24 37.91a20.17 20.17 0 012.67 7.31 17.62 17.62 0 01-1.43 7.65c-3.57 9.61-9.73 18.53-10.43 28.76a4.65 4.65 0 00.75 3.42 4.3 4.3 0 002.58 1.16c10.8 1.85 20.14-7.72 25.41-17.33a81.24 81.24 0 0010.02-34.52c1.09-20.36-6.21-40.39-5.76-60.77.52-23.17 10.99-46.5 4.86-68.85z"
        fill="#3e373a"
      />
      <path
        fill="#c3c7d9"
        d="M581.79 492.73l39.67 1.27-5.69-29.42-30.39 2.89-3.59 25.26z"
      />
      <path
        d="M704.71 423c-2.67 3.33-13 9.33-14 11.33s-13.33 8-19.67 9-26.33 5.34-30 7.67c-2.63 1.68-23.74 7-37.61 9.95a106.75 106.75 0 01-11.39 2.05c-6 .33-71.66-22-71.66-22l12.66-13 .7-.24c3.58-1.21 20.12-6.8 29.3-9.46 10.34-3 22.34-15.33 22.34-15.33s17.66-6 20-6.67-6-23.33-6-23.33 38.33-5.32 53.33-9.83 49.67-2.84 56 14.83-1.29 41.7-4 45.03z"
        fill="#4b4b5b"
      />
      <path
        d="M530.04 479.33s-7.66 8-15.33 7.34-34.49 2-34.49 2a53.77 53.77 0 00-13.51 7.83c-6.27 4.94-9.6 1-10.22.16l-.11-.16c-3.34 10.51-11 2.5-11 2.5s3.33-32 2.31-36 6.59-10.87 6.59-10.87l9-2.29 22.8-5.84 32.67 11.33z"
        fill="#e7c7ca"
      />
      <path
        d="M463.24 449.84l-6.75 46.82-.11-.16c-3.34 10.51-11 2.5-11 2.5s3.33-32 2.31-36 6.59-10.87 6.59-10.87zM510.42 316.66s17.66 6 33 0M570.71 328s7.33 3.66 13 0M570.71 336.68s12.33 1.65 14.67-1.68M566.71 355.33s23.16-3 28.91-7M496.04 348.33s13 7.33 22.67 7M603.42 460.95a106.75 106.75 0 01-11.39 2.05c-6 .33-71.66-22-71.66-22l12.66-13 .7-.24c2 1.41 3.64 2.62 4.81 3.54 5.51 4.34 10.83-1.33 12.83-1.33s19.33 14.33 19.33 14.33 16 3.67 18.67 7 12 2.67 13.66 5c.5.72.56 2.49.39 4.65z"
        opacity={0.1}
      />
      <path
        d="M480.22 374.33s-16.18.93-25.51-3-40.33-13-49.33-6.63-30.67 12-20.67 37.34 14.67 26 14.67 26a36.1 36.1 0 018 8.3c3 4.67 31 15.33 38 15.33s19.33 0 36.66 12 33 13.34 33 13.34 22 9 28.85 11 38.15 10.66 45.49 8 12-19.34 12-19.34 3.33-15 1.66-17.33-11-1.67-13.66-5-18.67-7-18.67-7S553.42 433 551.42 433s-7.32 5.66-12.83 1.33a292.69 292.69 0 00-34.51-22c-12.66-6.67-23.86-38-23.86-38z"
        fill="#4b4b5b"
      />
      <path
        d="M447.69 384a19.1 19.1 0 0116.39 4.33c8 6.67 34.92 20.06 34.92 20.06M647.71 383.58s-35.67 5.4-42.33 12.73"
        opacity={0.1}
      />
      <path
        d="M688.71 494h-1.57c-5.64-.2-24.75-.8-28.43 0-4.33 1-61.67 0-61.67 0l11.21-2.33s-4.16-14.58-1.52-15.79c0 0-15-9.88-3.69-16.55s23.5-3.86 23.5-3.86l28.39-9.62 5.45-1.85s32 1.67 40.66 23.67S688.71 494 688.71 494z"
        fill="#e7c7ca"
      />
      <path
        d="M688.71 494h-1.57c9.31-7.68 30.37-31.06-32.21-48.1l5.45-1.85s32 1.67 40.66 23.67S688.71 494 688.71 494z"
        opacity={0.1}
      />
      <circle cx={629.88} cy={466.33} r={1.75} fill="#4b4b5b" />
      <circle cx={619.71} cy={469.22} r={1.75} fill="#4b4b5b" />
      <g opacity={0.1}>
        <path d="M570.16 99.41a77.59 77.59 0 00-5.74-32.14c-13 1.94-27.24-8.09-39.08-2.09-8.76 4.44-11.51 15.57-12 25.38-.12 2.59-.14 5.18-.09 7.77 0-.92 0-1.85.09-2.77.46-9.81 3.21-20.94 12-25.38 11.84-6 26.06 4 39.08 2.09a77.38 77.38 0 015.74 27.14zM469.42 97.58a33.32 33.32 0 00-.13-6.54c-1.06-8.8-5.87-17.21-6.74-25.79-1.12 10.35 5.47 20.29 6.74 30.79.13.54.13 1.02.13 1.54zM522.11 187.32c-.62 7.42-2.37 15.35-8 20.27s-16 4.65-19.13-2.09c-1-2-1.15-4.33-2.12-6.33-2.22-4.58-7.68-6.36-12.45-8.15-13.55-5.07-26.62-15-29.53-29.21a30.68 30.68 0 01-.53-3.9 31.52 31.52 0 00.53 8.9c2.91 14.17 16 24.14 29.53 29.21 4.77 1.79 10.23 3.57 12.45 8.15 1 2 1.17 4.31 2.12 6.33 3.15 6.74 13.54 7 19.13 2.09s7.33-12.85 8-20.27a114.29 114.29 0 00.31-11.74c0 2.27-.13 4.51-.31 6.74zM599.35 114.07v4.33c.56-18.6 7.38-37.3 6.71-55.51-.52 16.84-6.33 34.06-6.71 51.18zM577.89 189.31a12.89 12.89 0 00.23-3.61 20 20 0 00-2.67-7.31c-5.78-11-12.37-22.26-13.15-34.47 0 .52-.07 1-.08 1.56-.4 13.54 6.91 25.93 13.23 37.91a24 24 0 012.44 5.92zM605.1 174.84a81.37 81.37 0 01-10.09 34.52c-5.28 9.61-14.61 19.18-25.42 17.33a4.25 4.25 0 01-2.58-1.17 2.5 2.5 0 01-.47-.78c-.12.78-.22 1.57-.28 2.37a4.61 4.61 0 00.75 3.41 4.25 4.25 0 002.58 1.17c10.81 1.85 20.14-7.72 25.42-17.33a81.37 81.37 0 0010.09-34.52c.12-2.34.13-4.67.06-7-.02.67-.02 1.33-.06 2z" />
      </g>
      <path
        d="M606.73 475.88s25.31 10.62 42-12.88M611.71 494.44s20.67-13.44 47-.44M473.35 491.39s8.68-19.58 31.86-4.65"
        fill="none"
        stroke="#000"
        strokeMiterlimit={10}
        opacity={0.1}
      />
      <path
        d="M445.21 201.83l17.7-16s68.63-4.5 71.47 18.83c0 0 24.33-27.66 75.5-21.5l21.65 17.24-59.84 26.26-58.15 20.17-42.83-19.17z"
        opacity={0.1}
      />
      <path
        d="M445.21 202.83l17.7-16s68.63-4.5 71.47 18.83c0 0 24.33-27.66 75.5-21.5l21.65 17.24-59.84 26.26-58.15 20.17-42.83-19.17z"
        fill="#d5d6db"
      />
      <path
        opacity={0.1}
        d="M437.38 204.83l7.83 93.67 83 4.17-3.6-93.27-.07-1.57-87.16-3z"
      />
      <path
        fill={props?.tertiary || '#6c63ff'}
        d="M437.38 202.83l7.83 93.67 83 4.17-3.6-93.27-.07-1.57-87.16-3z"
      />
      <path
        opacity={0.1}
        d="M635.33 202.83l-85.62 12.84v94.09l83.67-12.09 1.95-94.84z"
      />
      <path
        fill={props?.tertiary || '#6c63ff'}
        d="M635.33 200.83l-85.62 12.84v94.09l83.67-12.09 1.95-94.84z"
      />
      <path
        fill="#fff"
        opacity={0.3}
        d="M615.14 223.79l-46.25 5.14 1.01 15.76 45.21-4.94.03-15.96z"
      />
      <path
        d="M449.71 346.66l4.71 12.67s7 6 14.66 3 14.34-4.49 17.67-7.41 8-17.59 8-17.59 4.67-16 9.33-20 17-59.11 0-53.72-30 55.39-30 55.39-3 3.66-7.33 4-13-.67-14.67 3-7.37 13.33-2.37 20.66z"
        fill="#be6f72"
      />
      <path
        d="M549.71 215.66a28.8 28.8 0 01-25.11-6.26l3.61 93.26s8.5 9.2 21.5 7.1z"
        opacity={0.1}
      />
      <path
        d="M549.71 213.66a28.8 28.8 0 01-25.11-6.26l3.61 93.26s8.5 9.2 21.5 7.1z"
        fill={props?.tertiary || '#6c63ff'}
      />
      <path
        d="M549.71 213.66a28.8 28.8 0 01-25.11-6.26l3.61 93.26s8.5 9.2 21.5 7.1zM551.71 203.15s34.83-10.65 43.91-9.15M512.75 198.5s-33.76-8-39.4-5.73M573.67 204.48s23.29-8.54 31.71-4.48M561.94 418.71a76.56 76.56 0 0111.48-7.13c6-2.89 17-10.39 17-10.39M473.35 316.66s-14.61 11.95-19 13-7.1 10.37-7.1 10.37"
        opacity={0.1}
      />
      <path
        d="M626.74 344.88l-4.66 12.7s-7 6-14.67 3-14.33-4.49-17.67-7.41-8-17.59-8-17.59-4.66-16-9.33-20-17-59.11 0-53.72 30 55.39 30 55.39 3 3.66 7.33 4 13-.67 14.67 3 7.33 13.33 2.33 20.63z"
        fill="#be6f72"
      />
      <path d="M618.57 321.52s9.55 6.14 9.51 13.48" opacity={0.1} />
      <circle cx={537.54} cy={98.87} r={44.67} fill="#be6f72" />
      <path
        d="M509.49 86.88c5.42-.85 10.17-4 15.35-5.81 11.59-4.07 24.41-1.28 36.14 2.39 4.5 1.41 9.07 3 13.79 3s9.73-1.93 12.14-6c2.22-3.74 1.79-8.6-.08-12.53s-5-7.09-8.16-10.07c-10.4-9.82-23.3-19-37.57-18-5.74.41-11.23 2.46-16.51 4.73a182 182 0 00-19.38 9.76c-4.81 2.79-13.72 6.52-16.49 11.62-6.3 11.49 10.97 22.45 20.77 20.91z"
        fill="#3e373a"
      />
      <path
        d="M586.91 76.26c-2.41 4.07-7.42 6-12.14 6s-9.29-1.53-13.8-2.94c-11.73-3.67-24.54-6.47-36.14-2.39-5.17 1.81-9.93 5-15.35 5.8-7.9 1.24-20.62-5.64-22-14.39-1.55 10.11 13.2 18.77 22 17.39 5.42-.85 10.18-4 15.35-5.8 11.6-4.08 24.41-1.28 36.14 2.39 4.51 1.41 9.07 3 13.8 2.94s9.73-1.92 12.14-6a11.71 11.71 0 001.4-7.31 10.78 10.78 0 01-1.4 4.31z"
        opacity={0.1}
      />
      <path
        d="M949.42 618.21s5.93 7.75-2.74 19.46-15.81 21.59-12.93 28.89c0 0 13.08-21.74 23.72-22.05s3.64-13.23-8.05-26.3z"
        fill={props?.tertiary || '#6c63ff'}
      />
      <path
        d="M949.42 618.21a9.6 9.6 0 011.21 2.43c10.38 12.2 15.92 23.59 5.93 23.87-9.3.27-20.45 16.9-23.12 21.09a9.78 9.78 0 00.31 1s13.08-21.74 23.72-22.05 3.64-13.27-8.05-26.34z"
        opacity={0.1}
      />
      <path
        d="M960.42 628.09c0 2.73-.31 4.94-.68 4.94s-.69-2.21-.69-4.94.38-1.44.76-1.44.61-1.29.61 1.44z"
        fill="#ffd037"
      />
      <path
        d="M964.21 631.35c-2.39 1.3-4.48 2.09-4.66 1.76s1.61-1.66 4-3 1.45-.36 1.63 0 1.43-.07-.97 1.24z"
        fill="#ffd037"
      />
      <path
        d="M918.08 618.21s-5.93 7.75 2.74 19.46 15.81 21.59 12.92 28.89c0 0-13.07-21.74-23.72-22.05s-3.6-13.23 8.06-26.3z"
        fill={props?.tertiary || '#6c63ff'}
      />
      <path
        d="M918.08 618.21a9.6 9.6 0 00-1.21 2.43c-10.38 12.2-15.92 23.59-5.93 23.87 9.29.27 20.45 16.9 23.12 21.09a7.72 7.72 0 01-.32 1s-13.07-21.74-23.72-22.05-3.6-13.27 8.06-26.34z"
        opacity={0.1}
      />
      <path
        d="M907.06 628.09c0 2.73.3 4.94.68 4.94s.69-2.21.69-4.94-.39-1.44-.76-1.44-.61-1.29-.61 1.44z"
        fill="#ffd037"
      />
      <path
        d="M903.28 631.35c2.39 1.3 4.48 2.09 4.66 1.76s-1.61-1.66-4-3-1.45-.36-1.63 0-1.43-.07.97 1.24z"
        fill="#ffd037"
      />
      <ellipse
        cx={933.75}
        cy={716.37}
        rx={62}
        ry={9.51}
        fill={props?.tertiary || '#6c63ff'}
        opacity={0.1}
      />
      <path
        d="M965.66 656.11l-.3 2.42-.42 3.42-.17 1.43-.42 3.42-.18 1.43-.41 3.41-4.75 38.9c-.42 3.47-6.09 6.18-12.94 6.18h-24.65c-6.85 0-12.51-2.71-12.94-6.18l-4.75-38.9-.42-3.41-.17-1.43-.42-3.42-.18-1.43-.41-3.42-.3-2.42c-.23-2 2.83-3.62 6.71-3.62h50.42c3.87 0 6.94 1.65 6.7 3.62z"
        fill="#65617d"
      />
      <path
        fill="#9d9cb5"
        d="M965.36 658.53l-.41 3.42h-62.4l-.42-3.42h63.23zM964.77 663.38l-.41 3.42h-61.22l-.42-3.42h62.05zM964.18 668.23l-.42 3.42h-60.03l-.41-3.42h60.86z"
      />
    </svg>
  );
}
